import { type MaybeRef, toValue } from 'vue';

import {
  cancelTeamMemberInvite,
  createTeam,
  inviteTeam,
  inviteTeamMembers,
  leaveTeam,
  renameTeam,
  resendTeamMemberInvite,
  uninviteTeam,
  updateTeam,
} from './api';

export const createTeamMutation = () => ({
  mutationFn: (data: { name: string; color?: string }) => createTeam(data),
});

export const updateTeamMutation = (teamUuid: MaybeRef<string>) => ({
  mutationFn: (data: { name: string; color: string }) => updateTeam(toValue(teamUuid), data),
});

export const renameTeamMutation = () => ({
  mutationFn: (data: { uuid: string; name: string }) => renameTeam(data),
});

export const leaveTeamMutation = (teamUuid: MaybeRef<string>) => ({
  mutationFn: () => leaveTeam(toValue(teamUuid)),
});

export const inviteTeamMutation = () => ({
  mutationFn: (data: { project_uuid: string; team_uuid: string }) => inviteTeam(data),
});

export const uninviteTeamMutation = () => ({
  mutationFn: (projectUuid: string) => uninviteTeam(projectUuid),
});

export const inviteTeamMembersMutation = (teamUuid: MaybeRef<string>) => ({
  mutationFn: (members: string[]) => inviteTeamMembers({ uuid: toValue(teamUuid), members }),
});

export const cancelTeamMemberInviteMutation = (teamUuid: MaybeRef<string>) => ({
  mutationFn: (email: string) => cancelTeamMemberInvite({ uuid: toValue(teamUuid), email }),
});

export const resendTeamMemberInviteMutation = (teamUuid: MaybeRef<string>) => ({
  mutationFn: (email: string) => resendTeamMemberInvite({ uuid: toValue(teamUuid), email }),
});
